module.exports = __webpack_public_path__ + "static/media/play.5d57b307.svg";